module.exports = __webpack_public_path__ + "img/home-page-background.dc997b3d.jpg";